import styled from 'styled-components';

import { FontSizes, FontWeights, Text, TextElements, units } from '@calm-web/design-system';

export const Container = styled.div`
	margin-bottom: ${units(5)};
`;

export const SectionTitle = styled(Text).attrs({
	el: TextElements.H2,
	size: FontSizes.xl,
	weight: FontWeights.Light,
})`
	margin-bottom: ${units(1.4)};
`;

export const SectionBody = styled.div``;
